import { type ForkPageCountry, type ForkPageNavigationProps } from "~/pages/ForkPage/ForkPage";
import { Link } from "~/common/components/Link";
import { Accordion, AccordionDetails, AccordionSummary } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "~/features/categoryNavigation/components/LanguageSelector";
import { styled } from "~/common/mui";

export const MobileForkPageNavigation = ({ subtitle, regions }: ForkPageNavigationProps) => {
  const { t } = useTranslation();
  const makeLink = ({ title, url, openInNewTab }: ForkPageCountry) => (
    <Link key={title} href={url} target={openInNewTab ? "_blank" : undefined}>
      {t(title)}
    </Link>
  );

  return (
    <div>
      <ForkSubtitle className="scha__fork__subtitle">{subtitle}</ForkSubtitle>

      <div className={"scha__fork__mobile-regions"}>
        {regions.map((region) => {
          const countriesPerColumn = Math.floor((region.countries.length + 1) / 2);

          return (
            <Accordion key={region.title}>
              <AccordionSummary>{t(region.title)}</AccordionSummary>
              <AccordionDetails>
                <RegionCountries className="scha__fork__region__countries">
                  <RegionCountriesColumn className="scha__fork__region__countries__column">
                    {region.countries.slice(0, countriesPerColumn).map(makeLink)}
                  </RegionCountriesColumn>

                  {region.countries.length > countriesPerColumn && (
                    <RegionCountriesColumn className="scha__fork__region__countries__column">
                      {region.countries.slice(countriesPerColumn).map(makeLink)}
                    </RegionCountriesColumn>
                  )}
                </RegionCountries>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
      <ForkUnderline className="scha__fork__underline fullbleed" />
      <LanguageSelector />
    </div>
  );
};

const ForkSubtitle = styled("h2")(({ theme }) => ({
  ...theme.typography.titleLarge,
  margin: `0 0 ${theme.spacing(3)}`,
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

const RegionCountries = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  padding: 0,
  "& > * + *": {
    marginLeft: theme.spacing(4),
    padding: 0,
  },
}));

const RegionCountriesColumn = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  "& > * + *": {
    marginTop: theme.spacing(2),
  },
}));

const ForkUnderline = styled("hr")(({ theme }) => ({
  border: "none",
  borderTop: `1px solid ${theme.palette.divider}`,
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(4),
}));
